import TrueFalseQuestionTemplate from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate'
import {
  spinePosturePNG,
  spinePostureWEBP,
} from '~/pages/anatomyV2/spinePosture/constants'
import { COLORS } from '~/shared/constants/uiConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 2

const SpinePostureAnatomyV2 = (props: TPageProps) => (
  <TrueFalseQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.spinePosture.title"
    factI18nKey="onboarding.spinePosture.fact"
    questionImagePNG={spinePosturePNG}
    questionImageWEBP={spinePostureWEBP}
    questionImageAlt="Sitting posture and spine alignment"
    question="Spot the fake: sitting posture"
    cardBackground={COLORS.PURPLE_100}
    firstBehindColor="#FFD387"
    secondBehindColor={COLORS.WHITE}
  />
)

export default SpinePostureAnatomyV2
